import { AlertTriangle, Info } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const messages = {
  historical: {
    title: "Historischer Zeitraum",
    description: "Der ausgewählte Zeitraum liegt vollständig in der Vergangenheit – Prognosen sind deaktiviert.",
    icon: Info,
  },
  mixed: {
    title: "Historie + Prognose",
    description: "Der Zeitraum reicht in die Zukunft – Prognosen starten ab",
    icon: Info,
  },
  future: {
    title: "Zukunftszeitraum",
    description: "Der Zeitraum liegt komplett in der Zukunft – es werden keine Berechnungen durchgeführt.",
    icon: AlertTriangle,
  },
};

const noForecastMessages = {
  historical: {
    title: "Historischer Zeitraum",
    description: "Auswertung ohne Prognose – es werden nur historische Daten berücksichtigt.",
    icon: Info,
  },
  mixed: {
    title: "Nur historische Auswertung",
    description: "Zukunftsanteile werden ignoriert – es zählen Daten bis heute.",
    icon: Info,
  },
  future: {
    title: "Zukunftszeitraum",
    description: "Prognosen sind deaktiviert – es werden nur Daten bis heute ausgewertet.",
    icon: AlertTriangle,
  },
};

export default function DashboardRangeNotice({ mode, forecastStartLabel, forecastEnabled = true }) {
  const config = forecastEnabled
    ? messages[mode] || messages.mixed
    : noForecastMessages[mode] || noForecastMessages.mixed;
  const Icon = config.icon;

  return (
    <Card className="border-slate-200 bg-white/80" data-testid="dashboard-range-notice">
      <CardContent className="flex items-start gap-3 p-4 text-sm text-slate-600">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-600">
          <Icon className="h-4 w-4" />
        </span>
        <div>
          <div className="text-sm font-semibold text-slate-900">{config.title}</div>
          <div className="text-xs">
            {config.description}
            {forecastEnabled && mode === "mixed" && forecastStartLabel ? ` ${forecastStartLabel}.` : ""}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}